import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiNavigation, FiHeart } = FiIcons;

const bonaoMapUrl = 'https://media-manager-c.questera.ai/greta-media/786069decac80ebfda9758781ecad48f576fd486e338363dff55357567d6916b51c713fb933d539c7b707900e265a4cf/images/aW1hZ2UvcG5n/0eac1a7c9a6fdc35373cd006ecc66220.png';

function LocalSection() {
  return (
    <section className="local-section section" id="local">
      <div className="container local-section__grid">
        <motion.div
          className="local-section__visual"
          initial={{ opacity: 0, x: -25 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.25 }}
        >
          <img
            className="local-section__bonao-map"
            src={bonaoMapUrl}
            alt="Mapa de República Dominicana con Bonao destacado"
            loading="lazy"
          />
          <div className="local-section__place">
            <small>Monseñor Nouel</small>
            <strong>Bonao</strong>
            <span>Zona principal de servicio</span>
          </div>
        </motion.div>

        <motion.div
          className="local-section__content"
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="eyebrow">
            <SafeIcon icon={FiHeart} /> Somos de aquí
          </span>
          <h2>Hecho en Bonao,<em>para Bonao.</em></h2>
          <p>
            Conocemos nuestra ciudad,sus comercios,sus calles y su gente.
            Cuando necesites resolver algo,tienes un Muchacho E’ Mandao cerca.
          </p>
          <span className="local-section__tag">
            <SafeIcon icon={FiNavigation} /> Servicio cercano,rápido y local
          </span>
        </motion.div>
      </div>
    </section>
  );
}

export default LocalSection;